import { mapColors, mapColorsHover } from '../../helpers/colorHelper.js';
import styled, { css } from 'styled-components';

const btnSize = (small)=>{
    return small ? "32px" : "48px";
};
const getButtonPadding = (iconBtn, small, hasChildren)=>{
    // buttons with icons but no text
    if (iconBtn && !hasChildren) {
        if (small) {
            return "8px";
        }
        return "14px";
    }
    // buttons with icons and text
    if (iconBtn) {
        if (small) {
            return "2px 8px";
        }
        return "14px 16px";
    }
    // buttons with only text
    if (small) {
        return "6px 16px";
    }
    return "14px 24px";
};
const getButtonColor = (theme, color)=>{
    if (color === "black") {
        return theme.colors.Background;
    }
    if (color === "grey") {
        return theme.colors.Foreground;
    }
    if (color === "white") {
        return "#000";
    }
    return "#fff";
};
const Btn = styled.button.withConfig({
    shouldForwardProp: (prop, defaultValidatorFn)=>![
            "transientDisabled",
            "color"
        ].includes(prop) && defaultValidatorFn(prop)
}).withConfig({
    displayName: "styles__Btn",
    componentId: "sc-2e078f7f-0"
})`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ iconBtn , small , hasChildren  })=>getButtonPadding(iconBtn, small, hasChildren)};
    height: ${({ small  })=>btnSize(small)};
    min-width: ${({ small  })=>btnSize(small)};
    width: ${({ fullWidth  })=>fullWidth ? "100%" : "fit-content"};

    color: ${({ theme , color , outlined  })=>outlined ? mapColors({
        theme,
        color: color === "grey" || color === "white" ? theme.colors.Foreground : color
    }) : getButtonColor(theme, color)};
    background-color: ${({ theme , outlined , color  })=>outlined ? "transparent" : mapColors({
        theme,
        color
    })};
    border: 2px solid
        ${({ theme , outlined , borderColor  })=>outlined ? borderColor || theme.colors["Level 1"] : "transparent"};
    border-radius: 88px;
    box-sizing: border-box;
    outline: transparent;
    overflow: hidden;
    cursor: pointer;
    transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.3s;

    text-decoration: none;

    ${(props)=>props.transientDisabled && css`
            color: ${({ theme  })=>theme.colors["Level 1"]};
            background-color: ${({ theme  })=>theme.colors["Level 1"]};
            border-color: transparent;
            cursor: not-allowed;
        `}

    &:hover,
    &:active {
        ${({ transientDisabled , color , theme , outlined  })=>!transientDisabled && css`
                color: ${color === "black" || color === "grey" || color === "white" ? theme.colors.Foreground : theme.colors.Background};
                background-color: ${outlined ? mapColors({
        theme,
        color
    }) : mapColorsHover({
        theme,
        color
    })};
                border-color: transparent;
            `}
    }
`;
const BtnContent = styled.div.withConfig({
    displayName: "styles__BtnContent",
    componentId: "sc-2e078f7f-1"
})`
    ${({ theme , typography  })=>theme.typography[typography]};
    display: flex;
    align-items: center;
    overflow: hidden;
    max-width: 100%;
`;
const BtnText = styled.span.withConfig({
    displayName: "styles__BtnText",
    componentId: "sc-2e078f7f-2"
})`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
const BtnIcon = styled.span.withConfig({
    displayName: "styles__BtnIcon",
    componentId: "sc-2e078f7f-3"
})`
    display: inline-flex;
    align-self: center;
    color: currentColor;
    fill: currentColor;
    max-width: ${({ iconSize , small  })=>iconSize ? iconSize : small ? "20px" : "24px"};

    ${({ position , theme: { spacers  }  })=>position === "start" ? `margin-right: ${spacers.M};` : `margin-left: ${spacers.M};`}

    &:only-child {
        justify-self: center;
        margin: 0;
    }
`;

export { Btn, BtnContent, BtnIcon, BtnText };
